import {request, serviceUrl} from "@/utils/request";

//获取型号可视化
export function listByModelId(modelId) {
    return request({
        params: {
            modelId
        },
        url: serviceUrl.deviceService + '/device/model-visual/listByModelId'
    })
}
